(function($) {
    $(document).ready(function() {            
        initBook();
    });

    function initBook() {
        $('.book-frame').dismiss({ 
            ignore: [ '.book-btn' ],
            openClass: 'active',
            closed: function() {
                $(".book-frame").removeClass('active');
                $(".book-frame").animate(
                    {
                        right: '-100%',
                        opacity: 0
                    }
                );
            }
        }); 

        $('.close-btn').click(function() {
            $(".book-frame").removeClass('active');
            $(".book-frame").animate(
                {
                    right: '-100%',
                    opacity: 0
                }
            );
        })

        $('.book-btn').click(function() {
            $(".book-frame").addClass('active');
            $(".book-frame").animate(
                {
                    right: '0px',
                    opacity: 1
                }
            );
        });
    }
})(jQuery);